import { render, staticRenderFns } from "./DetailTaskFlow.vue?vue&type=template&id=29227237&scoped=true"
import script from "./DetailTaskFlow.vue?vue&type=script&lang=js"
export * from "./DetailTaskFlow.vue?vue&type=script&lang=js"
import style0 from "./DetailTaskFlow.vue?vue&type=style&index=0&id=29227237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29227237",
  null
  
)

export default component.exports